import { ModelBase } from '../../shared/base/model-base';

export class NumberingListItem extends ModelBase {
  number?: number;
  title?: string;
  content?: string;
}




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/shared/numbering-list-item.ts